/* eslint-disable react/prop-types */

'use strict';

const { Component, h } = require('preact');
const OptionMessages = require('./messages/template');
const OptionPricing = require('./pricing');
const UrgencyPriceLabel = require('./pricing/urgency_price_label');
const getOptionPromoIneligible = require('./promo_ineligible');

const renderTitle = props => {
  const {
    isPriceSummary,
    isTraitsSummary,
    option: { title },
  } = props;
  if (!title || isPriceSummary || isTraitsSummary) {
    return null;
  }
  return h('h3', null, title);
};

class OptionDetails extends Component {
  constructor(props) {
    super(props);

    const { isTraitsSummary, option, priceSummary, variations } = props;
    const currentOption = option || priceSummary;
    const showPriceLabel = !!currentOption.pricing.pricingLabel;
    this.state = {
      allTraitsSelected: isTraitsSummary
        ? Boolean(
            variations &&
              variations.preSelectedTraits &&
              variations.preSelectedTraits.length
          )
        : undefined,
      currentOption,
      showPriceLabel,
    };

    this.renderOptionMessage = this.renderOptionMessage.bind(this);
  }

  componentDidMount() {
    // eslint-disable-next-line
    window.BuyButtonEventPipe.on(
      'option_updated',
      ({ allTraitsSelected, optionUuid }) => {
        const newOption = this.props.multiOption.find(
          option => option.uuid === optionUuid
        );
        if (newOption) {
          this.setState({
            allTraitsSelected,
            currentOption: newOption,
          });
        }
      }
    );
  }

  renderOptionMessage(msg) {
    return msg ? h(OptionMessages, msg) : null;
  }

  render(props, { allTraitsSelected, currentOption }) {
    const { isRefreshLeftAlign, isTraitsSummary, defaultMessages } = props;
    const {
      isModalOption,
      isUrgencyPricing,
      showDoubleStrikeThroughPrice,
      pricing: { pricingLabel, showIlsTimeLeft },
    } = currentOption;

    const propsToPass = {
      ...props,
      option: currentOption,
      allTraitsSelected,
      showPriceLabel:
        !!pricingLabel && (!isTraitsSummary || !allTraitsSelected),
    };

    const showUrgencyPriceLabel =
      isTraitsSummary || (!showDoubleStrikeThroughPrice && isModalOption);

    /**
     * TODO: Refactor further to remove this flag if possible
     */
    const showRefreshUrgencyPriceLabel =
      isRefreshLeftAlign &&
      !isTraitsSummary &&
      (showDoubleStrikeThroughPrice || isModalOption);

    const breakoutMessagesClasses = `breakout-messages${
      isTraitsSummary ? ' has-traits' : ''
    }${showIlsTimeLeft ? ' with-price-label' : ''}${
      isUrgencyPricing ? ' urgency-pricing-offer' : ''
    }`;

    let messagesView;
    if (isTraitsSummary && !allTraitsSelected) {
      messagesView = defaultMessages.map(this.renderOptionMessage);
    } else {
      messagesView = propsToPass.option.messages.map(this.renderOptionMessage);
    }

    let promoIneligibleView;
    if ((!isTraitsSummary || allTraitsSelected) && isRefreshLeftAlign) {
      promoIneligibleView = getOptionPromoIneligible(currentOption);
    }

    return h(
      'div',
      {
        class: `option-details c-txt-gray-dk`,
      },
      renderTitle(propsToPass),
      h(
        'div',
        {
          class: `breakout-pricing-messages`,
        },
        h(
          'div',
          {
            class: breakoutMessagesClasses,
          },
          promoIneligibleView,
          messagesView,
          showUrgencyPriceLabel || showRefreshUrgencyPriceLabel
            ? h(UrgencyPriceLabel, propsToPass)
            : null
        ),
        h(OptionPricing, propsToPass)
      )
    );
  }
}

module.exports = OptionDetails;
